import QuestionHollow from './view';

export default QuestionHollow;


// WEBPACK FOOTER //
// ./src/entry_question_editor/question/exercise/step/sub-question/hollow/index.js